module.exports = __webpack_public_path__ + "static/media/health-white.df81ee75.svg";